import React, { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material';
import { useReturnGlobalLoaderStatus } from '../features/notifications/notificationsSlice';

export default function GlobalPreloader() {

    const status = useReturnGlobalLoaderStatus()

    const baseContainerClassName: string = "global-preloader-container"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    useEffect(() => {
        if (status){
            setContainerClassName(baseContainerClassName + " active")
        }else{
            setContainerClassName(baseContainerClassName)
        }
    }, [status])

    return(
        <div className={containerClassName}>
            <div className="content-of-global-preloader-container">
                <CircularProgress />
            </div>
        </div>
    )
}